/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import roadAnalysisIcon from "../../images/landing_images/road-analysis.svg";

export const ROAD_ANALYSIS_CONSTANTS = {
  app: {
    title: 'Road Analysis',
    icon: roadAnalysisIcon
  },
  landing: {
    title: 'Road Analysis',
    route: '/road-analysis',
    endpoints: {
      baseline: '/HttpTriggerRoadAnalysis',
      curv: '/HttpTriggerRoadAnalysis?type=curv',
      elev: '/HttpTriggerRoadAnalysis?type=elev',
    },
  },
};
